export default (el) => ({
  id: Number(el.SubscrId),
  code: String(el.SubscrCode),
  address: String(el.Address || ''),
  owner: Object.values(el.Name || {}).join(' '),
  debit: Number(el.Debit || 0) * -1,
});
